import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Boom from "../components/boom"

const RestoPage = () => (
  <Layout>
    <Seo title="whatsapp untuk restoran cafe rumah makan" />
    <div className="col-12 col-md-12 p-3 p-md-5 text-center"
	   style={{
      backgroundRepeat: 'no-repeat',
		  backgroundAttachment: 'fixed',
      backgroundPosition: 'center', 
      backgroundSize: 'cover',
      backgroundImage: `url(${('https://1.bp.blogspot.com/-0kSVnP2SUq8/YWxEr_Vin5I/AAAAAAAAKO4/tkq-mEXW2EQ-s_c6j5cjlP5bxRppUm3NACLcBGAsYHQ/s1024/13.jpg')})`
}}>
<div className="ratio ratio-16x9">
  <iframe src="https://www.youtube.com/embed/wuvIR7W34M4" title="whatsapp shop order untuk restoran cafe rumah makan" className="shadow rounded" allowfullscreen></iframe>
</div>
    
    </div>
    <div className="col-12 col-md-12 p-3 p-md-5 text-center"
      style={{
      backgroundRepeat: 'no-repeat',
		  backgroundAttachment: 'fixed',
      backgroundPosition: 'center', 
      backgroundSize: 'cover',
      backgroundImage: `url(${('https://1.bp.blogspot.com/-0kSVnP2SUq8/YWxEr_Vin5I/AAAAAAAAKO4/tkq-mEXW2EQ-s_c6j5cjlP5bxRppUm3NACLcBGAsYHQ/s1024/13.jpg')})`
}}
      >
	  
<div class="card shadow rounded bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
	 <div className="p-3 p-md-5 card shadow rounded bg-dark text-white">
<h1><a href="/resto" className="text-white">Whatshop order untuk Resto Cafe</a></h1>
 <StaticImage
      src="../images/rm.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
<p>Special untuk pengusaha kuliner restoran cafe rumah makan dalam kebutuhan handling order pelanggan secara online dan tentunya akan terintegrasi langsung dengan whatsapp secara langsung, ini tentu akan membantu agar proses order pelanggan semakin cepat dengan system dan skema integrasi chekcout whatsapp langsung ini.
</p>
<p>
Pada whatshop sendiri sudah dilengkapi dengan grouping menu yang memudahkan dalam pengelompokan menu makanan dan minuman sesuai dengan kategori nya, dengan skema ini akan membantu merapikan pembukuan serta pengelompokan menu sesuai dengan grouping nya.
</p>
<p>
Bukan hanya sekedar whatsapp order saja, tetapi dilengkapi dengan content management system yang membantu proses untuk pembuatan data menu makanan dan minuman include dengan harga dan gambar menu untuk diupload agar menarik perhatian pelanggan. Include dengan domain nama restoran cafe rumah makan plus cloud host akan menjadi menarik dengan all in one website dan applikasi dalam whatshop apps ini.
</p>
<p>
Pada premium paket temukan kemudahan dengan integrasi point of sale apps, aplikasi kasir restoran yang dapat digunakan dalam bertransaksi untuk mencatat pesanan pelanggan , mencetak bill, mencetak struk kasir via mesin kasir dan cek laporan pendapatan income detail.
</p>
<p>
Saat nya kini revolusi digital bisnis mu dengan whatshop , pilih layanan dan online kan toko mu sekarang.
</p>          
<h3><Link to="/price" class="btn btn-warning"  
style={{
backgroundRepeat: 'repeat',
backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
}}>Order Now</Link></h3>
</div>
          </div>
        </div>
		<Boom/>
      </Layout>
)

export default RestoPage
